import { render } from "./Design.vue?vue&type=template&id=69670d22"
import script from "./Design.vue?vue&type=script&lang=js"
export * from "./Design.vue?vue&type=script&lang=js"

import "./Design.vue?vue&type=style&index=0&id=69670d22&scope=true&lang=scss"
script.render = render

export default script